<template>
  <div>
    <h1 class="headline">ตอบกลับคอมเมนต์</h1>
    <v-layout class="my-3" justify-center align-content-center style="align-items: center">
      <v-flex> ตอบกลับคอมเมนต์ถูกปิดเนื่องจากป้องกันการบล็อคจาก Facebook </v-flex>
      <v-flex class="text-xs-right">
        <div v-if="selectedBot.replycommentflag" class="primary--text">เปิดใช้งานอยู่</div>
        <v-btn v-else outline color="primary" @click="handleToggleReplyCommentFlag()">
          เปิดใช้งาน
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import pageConfigApi from '@/api/page-config'
import { handleApiError } from '@/api/util'
export default {
  data() {
    return {
      input: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    async handleToggleReplyCommentFlag() {
      try {
        this.$store.dispatch('loading')
        const response = await pageConfigApi.postReplyCommentFlag({
          data: {
            replycommentflag: true,
            page_id: this.selectedBot.pageid
          }
        })
        if (response.status == 200 || response.status == 204) {
          const currentBot = {
            ...this.selectedBot,
            replycommentflag: true
          }

          const newbotlist = this.$store.state.botlist
          const botIndex = newbotlist.findIndex((oldbot) => {
            return this.selectedBot.pageid == oldbot.pageid
          })
          if (newbotlist) {
            newbotlist[botIndex].replycommentflag = true
            this.$store.dispatch('updateBotlist', newbotlist)
          }

          this.$store.dispatch('selectBot', currentBot)
          this.$swal.fire({
            title: this.$t('Successfully'),
            type: 'success'
          })
        }
        this.$store.dispatch('clear_loading')
      } catch (error) {
        handleApiError(error)
        this.$store.dispatch('clear_loading')
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/ReplyCommentFlagConfig.vue